// // app/providers.js
// "use client";
// import posthog from "posthog-js";
// import { PostHogProvider } from "posthog-js/react";
// import { ReactNode } from "react";

// const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY as string;
// const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST as string;

// if (typeof window !== "undefined") {
//   posthog.init(POSTHOG_KEY, {
//     api_host: POSTHOG_HOST,
//     person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
//   });
// }

// interface CSPostHogProviderProps {
//   children: ReactNode;
// }
// export function CSPostHogProvider({ children }: CSPostHogProviderProps) {
//   return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
// }

// app/providers.js
// "use client";
// import posthog from "posthog-js";
// import { PostHogProvider } from "posthog-js/react";

// const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY;
// const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST;

// if (typeof window !== "undefined") {
//   posthog.init(POSTHOG_KEY, {
//     api_host: POSTHOG_HOST,
//     person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
//   });
// }
// export function CSPostHogProvider({ children }) {
//   return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
// }

// app/providers.tsx
"use client";
import React, { useEffect, useState } from "react";
import { PostHogProvider } from "posthog-js/react";

// PHProvider lazily loads posthog-js and initializes it during idle time
// or on first user interaction (fallback). This prevents the PostHog bundle
// from blocking initial load and reduces TBT/LCP impact.
export function PHProvider({ children }: { children: React.ReactNode }) {
  const [client, setClient] = useState<any | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    let cancelled = false;

    const doInit = async () => {
      try {
        const { default: posthog } = await import("posthog-js");
        if (cancelled) return;
        posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
          api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
          person_profiles: "identified_only",
          capture_pageview: false,
          capture_pageleave: true,
        });
        if (!cancelled) setClient(posthog);
      } catch (e) {
        // swallow - analytics shouldn't break the app
        // eslint-disable-next-line no-console
        console.warn("PostHog failed to load:", e);
      }
    };

    const scheduleInit = () => {
      if ((window as any).requestIdleCallback) {
        (window as any).requestIdleCallback(() => doInit(), { timeout: 2000 });
      } else {
        // Fallback: init after a short timeout, and ensure we also init on first interaction
        const onFirstInteraction = () => {
          doInit();
          window.removeEventListener("pointerdown", onFirstInteraction);
          window.removeEventListener("keydown", onFirstInteraction);
        };
        window.addEventListener("pointerdown", onFirstInteraction, { once: true });
        window.addEventListener("keydown", onFirstInteraction, { once: true });
        setTimeout(() => {
          // only run if interaction didn't already trigger
          if (!client) doInit();
        }, 2000);
      }
    };

    scheduleInit();

    return () => {
      cancelled = true;
    };
    // intentionally do not include `client` in deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Until the client is ready, render children normally.
  if (!client) return <>{children}</>;

  return <PostHogProvider client={client}>{children}</PostHogProvider>;
}
